/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ day: NonNullable<unknown> }} Exercise_Sheet_Chart_Point_EmptyInputs */

const en_us2_exercise_sheet_chart_point_empty = /** @type {(inputs: Exercise_Sheet_Chart_Point_EmptyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day}: nothing logged`)
};

const pt_br2_exercise_sheet_chart_point_empty = /** @type {(inputs: Exercise_Sheet_Chart_Point_EmptyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day}: sem registro`)
};

const es_419_exercise_sheet_chart_point_empty = /** @type {(inputs: Exercise_Sheet_Chart_Point_EmptyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day}: sin registro`)
};

const pt_pt2_exercise_sheet_chart_point_empty = /** @type {(inputs: Exercise_Sheet_Chart_Point_EmptyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day}: sem registo`)
};

const fr_fr2_exercise_sheet_chart_point_empty = /** @type {(inputs: Exercise_Sheet_Chart_Point_EmptyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day} : rien d'enregistré`)
};

const de_de2_exercise_sheet_chart_point_empty = /** @type {(inputs: Exercise_Sheet_Chart_Point_EmptyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day}: nichts eingetragen`)
};

const it_it2_exercise_sheet_chart_point_empty = /** @type {(inputs: Exercise_Sheet_Chart_Point_EmptyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day}: nessuna registrazione`)
};

/**
* | output |
* | --- |
* | "{day}: nothing logged" |
*
* @param {Exercise_Sheet_Chart_Point_EmptyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_sheet_chart_point_empty = /** @type {((inputs: Exercise_Sheet_Chart_Point_EmptyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Sheet_Chart_Point_EmptyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_sheet_chart_point_empty(inputs)
	if (locale === "es-419") return es_419_exercise_sheet_chart_point_empty(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_sheet_chart_point_empty(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_sheet_chart_point_empty(inputs)
	if (locale === "de-DE") return de_de2_exercise_sheet_chart_point_empty(inputs)
	if (locale === "it-IT") return it_it2_exercise_sheet_chart_point_empty(inputs)
	return en_us2_exercise_sheet_chart_point_empty(inputs)
});
export { exercise_sheet_chart_point_empty as "exercise-sheet.chart_point_empty" }